/*
* 项目报价打印组件
*/

import { useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    Table,
    Modal, Button,
    ConfigProvider,
    Radio
} from 'antd';
import { UjoinParams, AddRequestHeaders, Html2pdf, currentDate } from '../../incs/FunHelper.js';

// 导出word
import { saveAs } from 'file-saver';
import docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import JSZipUtils from 'jszip-utils';
import expressionParser from 'docxtemplater/expressions.js'
// 导出word

// 导出excel
import ExcelJS from 'exceljs';
// 导出excel

import ZHCLOGO from '../../images/yd_logo.jpg';
import XZTLOGO from '../../images/xzt-logo-1.jpg';

/**
 * 打印报价
 */
const OfferPrinter = (props) => {
    const [open, setOpen] = useState(false);
    const [offerSorts, setOfferSorts] = useState([]);
    const [dataLists, setDataLists] = useState([]);
    const [format, setFormat] = useState('PDF');

    /**
     * 取消
     */
    const cancel = () => {
        setOpen(false);
        setOfferSorts([]);
        setDataLists([]);
        setFormat('PDF');
    }


    useEffect(() => {
        /**
         * 获取报价分类
         * @param {*} record 
         */
        const getOfferSorts = (record) => {
            const params = {
                'project_offer_ulid': record.key,
            };
            $.ajax({
                url: `${CNF.api}project/offer/sorts${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setOfferSorts(data.dat);
                        } else {
                            setOfferSorts([]);
                        }
                    }
                }
            })
        }

        /**
         * 获取报价清单
         * @param {*} record 
         */
        const getOfferLists = (record) => {
            const params = {
                'project_offer_ulid': record.key,
            };
            $.ajax({
                url: `${CNF.api}project/offer/lists${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setDataLists(data.dat);
                        } else {
                            setDataLists([]);
                        }
                    }
                }
            })
        }
        // 修改初始化
        if (props.record) {
            setOpen(true);
            getOfferSorts(props.record);
            getOfferLists(props.record);
        }
    }, [props]);

    // 执行打印
    const doPrinter = () => {
        // let oldStr = window.document.body.innerHTML;
        let newStr = document.getElementById('offer-print-info-id').innerHTML;
        window.document.body.innerHTML = newStr;
        window.print();
        window.location.reload();

    }

    const printer = (action) => {
        if (action === 'DOWNLOAD') {
            if (format === 'WORD') {
                word();
            } else if (format === 'EXCEL') {
                excel();
            } else {
                pdf();
            }
        } else {
            doPrinter();
        }
    }

    const pdf = () => {
        Html2pdf('offer-print-info-id', props.record.name + '.v' + props.record.version + '.', currentDate);
        cancel();
    }

    const word = () => {
        // 初始化项目实体
        const record = props.record;
        // 封装offeSort实体数据，添加分类清单列表
        let osLists = [];
        for (let i = 0; i < offerSorts.length; i++) {
            let ofLists = [];
            let sortItem = offerSorts[i];
            let k = 1;
            for (let j = 0; j < dataLists.length; j++) {
                let listItem = dataLists[j];
                if (sortItem.number === listItem.sort_number) {
                    listItem.key = k;   // 筛选后重新排序
                    k += 1;
                    ofLists.push(listItem);
                }
            }
            sortItem.ofLists = ofLists;
            // 金额小计amount subtotal
            let asLists = [
                {
                    asName: '金额小计：',
                    asValue: sortItem.amount,
                }
            ];
            // 如果税费小计>0，则加入小计
            if (sortItem.tax_amount > 0) {
                asLists.push({
                    asName: '税费小计：',
                    asValue: sortItem.tax_amount,
                })
            }
            sortItem.asLists = asLists;
            osLists.push(sortItem);
        }

        // 金额合计amount total
        let atLists = [
            {
                atName: '金额合计：',
                atValue: record.amount,
            }
        ]
        // 税费合计>0，则添加
        if (record.tax_amount > 0) {
            atLists.push({
                atName: '税费合计：',
                atValue: record.tax_amount,
            });
        }
        atLists.push({
            atName: '总计：',
            atValue: (parseFloat(record.amount) + parseFloat(record.tax_amount)).toFixed(CNF.DPL),
        });

        // 将备注内容以“\n”拆分成数组
        let descArr = [];
        let ds = record.description.split('\n')
        for (let i = 0; i < ds.length; i++) {
            let obj = { content: ds[i] }
            descArr.push(obj);
        }
        record.descArr = descArr;
        var wordData = {
            offerObj: record,
            offerSorts: osLists,
            atLists: atLists,
        };
        /**
         * 读取并获得模板文件的二进制内容，是 docxtemplater 提供的固定写法。
         * XZTOFFER.docx是模板，React 写在 public 里，我们在导出的时候，会根据此模板来导出对应的数据。
         */
        const TMPath = '/templates/' + props.preGroup + '/OFFER.docx';
        JSZipUtils.getBinaryContent(TMPath, function (error, content) {
            // 抛出异常
            if (error) { throw error; }
            // 创建一个 PizZip 实例，内容为模板的内容。
            let zip = new PizZip(content);
            // 创建并加载 docxtemplater 实例对象。
            let doc = new docxtemplater()
                // .attachModule(imageModule)  //图片导出功能
                .loadZip(zip)
                .setOptions({
                    paragraphLoop: true,
                    linebreaks: true,
                    parser: expressionParser,
                })
                .compile();

            // 生成一个代表 docxtemplater 对象的 zip 文件（不是一个真实的文件，而是在内存中的表示）
            doc.setData(wordData);
            try {
                doc.render();
            } catch (error) {
                function replaceErrors(key, value) {
                    if (value instanceof Error) {
                        return Object.getOwnPropertyNames(value).reduce(function (error, key) {
                            error[key] = value[key];
                            return error;
                        },
                            {});
                    }
                    return value;
                }
                console.log(JSON.stringify({ error: error }, replaceErrors));

                if (error.properties && error.properties.errors instanceof Array) {
                    const errorMessages = error.properties.errors
                        .map(function (error) {
                            return error.properties.explanation;
                        })
                        .join('\n');
                    console.log('errorMessages', errorMessages);
                }
                throw error;
            }

            var out = doc.getZip().generate({
                type: 'blob',
                mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            });
            // 将目标文件对象保存为目标类型的文件，并命名。
            saveAs(out, record.name + '.v' + record.version + '.' + currentDate + '.docx');
            // 退出报表界面
            cancel();
        });
    }

    const excel = () => {
        // 初始化项目实体
        const record = props.record;
        // 创建工作簿
        const workbook = new ExcelJS.Workbook();
        // 设置属性
        workbook.creator = 'Xzt';
        workbook.lastModifiedBy = 'Xzt';
        workbook.created = new Date(1985, 8, 30);
        workbook.modified = new Date();
        workbook.lastPrinted = new Date();
        // 将工作簿日期设置为 1904 年日期系统
        workbook.properties.date1904 = true;
        // 在加载时强制工作簿计算属性
        workbook.calcProperties.fullCalcOnLoad = true;
        // 添加工作表
        // 使用A4设置的页面设置，设置创建新工作表 - 横向
        const sheet = workbook.addWorksheet('报价明细', {
            pageSetup: { paperSize: 9, orientation: 'landscape' }
        });
        // 字体设置
        let titFont = { // 项目名称
            size: 16,
            bold: true
        }
        let bolFont = { // 字体加粗
            size: 12,
            bold: true
        }
        let conFont = { // 内容字体
            size: 12,
        }
        // 对齐方式
        let alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        // 边框设置
        let border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        // 设置列宽
        sheet.getColumn(1).width = 6;
        sheet.getColumn(2).width = 18;
        sheet.getColumn(3).width = 48;
        sheet.getColumn(4).width = 12;
        sheet.getColumn(5).width = 12;
        sheet.getColumn(6).width = 6;
        sheet.getColumn(7).width = 8;
        sheet.getColumn(8).width = 10;
        sheet.getColumn(9).width = 12;
        sheet.getColumn(10).width = 10;
        // 插入名称行
        sheet.addRow([]);
        // 合并名称行
        sheet.mergeCells('A1:J1');
        sheet.getCell('J1').value = record.name;
        sheet.getCell('J1').font = titFont;
        sheet.getCell('J1').alignment = alignment;
        sheet.getCell('J1').border = border;
        sheet.getRow(1).height = 32;
        // 分类循环写入表格
        let k = 2;
        // 金额小计行号数组
        let amountRowNums = [];
        // 税额小计行号数组
        let taxAmountRowNums = [];
        for (let i = 0; i < offerSorts.length; i++) {
            let sortItem = offerSorts[i];
            // 如果报价分类不止一项，则需要插入分类标题
            if (offerSorts.length > 1) {
                sheet.addRow([]);
                // 合并分类标题
                sheet.mergeCells(k, 1, k, 10);
                sheet.getCell('J' + k.toString()).value = sortItem.name;
                sheet.getCell('J' + k.toString()).font = bolFont;
                sheet.getCell('J' + k.toString()).alignment = alignment;
                sheet.getCell('J' + k.toString()).border = border;
                sheet.getRow(k).height = 26;
                k += 1; // 下移一行
            }
            // 添加标题
            sheet.addRow(['序号', '产品名称', '参数', '品牌', '规格型号', '单位', '数量', '单价', '合计', '备注']);
            // 标题添加背景色
            for (let m = 1; m < 11; m++) {
                sheet.getCell(k, m).font = bolFont;
                sheet.getCell(k, m).alignment = alignment;
                sheet.getCell(k, m).border = border;
                sheet.getCell(k, m).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFD9D9D9' },
                    bgColor: { argb: 'FFD9D9D9' }
                };
            }
            sheet.getRow(k).height = 26;
            // 
            k += 1; // 下移一行
            // 插入清单内容
            let num = 1;    // 分类序号
            let staRow = k; // 开始行
            for (let j = 0; j < dataLists.length; j++) {
                let listItem = dataLists[j];
                if (sortItem.number === listItem.sort_number) {
                    let rowLisObj = [];
                    rowLisObj[rowLisObj.length] = num;
                    rowLisObj[rowLisObj.length] = listItem.name;
                    rowLisObj[rowLisObj.length] = listItem.description;
                    rowLisObj[rowLisObj.length] = listItem.brand;
                    rowLisObj[rowLisObj.length] = listItem.model;
                    rowLisObj[rowLisObj.length] = listItem.unit;
                    rowLisObj[rowLisObj.length] = listItem.count;
                    rowLisObj[rowLisObj.length] = listItem.price;
                    rowLisObj[rowLisObj.length] = listItem.amount;
                    rowLisObj[rowLisObj.length] = listItem.remarks;
                    sheet.addRow(rowLisObj);
                    for (let m = 1; m < 11; m++) {
                        sheet.getCell(k, m).font = conFont;
                        if (m === 3) {
                            // 参数居左对齐
                            sheet.getCell(k, m).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                        } else {
                            sheet.getCell(k, m).alignment = alignment;
                        }
                        if (m === 7 || m === 8 || m === 9) {
                            sheet.getCell(k, m).numFmt = '0.00';
                        }
                        sheet.getCell(k, m).border = border;
                    }
                    // 金额行采用计算公式
                    sheet.getCell(k, 9).value = { formula: 'G' + k.toString() + '*H' + k.toString(), result: listItem.amount };
                    k += 1;     // 下移一行
                    num += 1;   // 增加序号  
                }
            }
            // 插入金额小计
            sheet.addRow([]);
            sheet.mergeCells(k, 1, k, 8);
            sheet.getRow(k).font = conFont;
            sheet.getRow(k).alignment = alignment;
            sheet.getRow(k).height = 26;
            sheet.getCell(k, 8).border = border;
            sheet.getCell(k, 8).value = '金额小计：';
            sheet.getCell(k, 9).border = border;
            sheet.getCell(k, 9).value = sortItem.amount;
            sheet.getCell(k, 10).border = border;
            // 插入求和公式
            sheet.getCell(k, 9).value = { formula: 'SUM(I' + staRow.toString() + ':I' + (k - 1).toString() + ')', result: sortItem.amount };
            sheet.getCell(k, 9).numFmt = '0.00';    // 保留2位有效数字
            // 记录金额小计行号
            amountRowNums.push('I' + k.toString());
            k += 1;
            // 插入税额小计
            if (sortItem.tax_amount > 0) {
                sheet.addRow([]);
                sheet.mergeCells(k, 1, k, 8);
                sheet.getRow(k).font = conFont;
                sheet.getRow(k).alignment = alignment;
                sheet.getRow(k).height = 26;
                sheet.getCell(k, 8).border = border;
                sheet.getCell(k, 8).value = '税费小计：';
                sheet.getCell(k, 9).border = border;
                sheet.getCell(k, 9).value = sortItem.tax_amount;
                sheet.getCell(k, 10).border = border;
                // 记录金额小计行号
                taxAmountRowNums.push('I' + k.toString());
                k += 1;
            }
        }
        // 插入金额合计
        sheet.addRow([]);
        sheet.mergeCells(k, 1, k, 8);
        sheet.getRow(k).font = bolFont;
        sheet.getRow(k).alignment = alignment;
        sheet.getRow(k).height = 26;
        sheet.getCell(k, 8).border = border;
        sheet.getCell(k, 8).value = '金额合计：';
        sheet.getCell(k, 9).border = border;
        sheet.getCell(k, 9).value = record.amount;
        sheet.getCell(k, 10).border = border;
        // 插入金额总计公式
        sheet.getCell(k, 9).value = { formula: amountRowNums.join('+'), result: record.amount };
        sheet.getCell(k, 9).numFmt = '0.00';    // 保留2位有效数字
        k += 1;
        // 插入税费合计
        if (record.tax_amount > 0) {
            sheet.addRow([]);
            sheet.mergeCells(k, 1, k, 8);
            sheet.getRow(k).font = bolFont;
            sheet.getRow(k).alignment = alignment;
            sheet.getRow(k).height = 26;
            sheet.getCell(k, 8).border = border;
            sheet.getCell(k, 8).value = '税费合计：';
            sheet.getCell(k, 9).border = border;
            sheet.getCell(k, 9).value = record.tax_amount;
            sheet.getCell(k, 10).border = border;
            // 插入税费总计公式
            sheet.getCell(k, 9).value = { formula: taxAmountRowNums.join('+'), result: record.tax_amount };
            sheet.getCell(k, 9).numFmt = '0.00';    // 保留2位有效数字
            k += 1;
        }
        // 插入总计
        let total = (parseFloat(record.amount) + parseFloat(record.tax_amount)).toFixed(CNF.DPL);
        sheet.addRow([]);
        sheet.mergeCells(k, 1, k, 8);
        sheet.getRow(k).font = bolFont;
        sheet.getRow(k).alignment = alignment;
        sheet.getRow(k).height = 26;
        sheet.getCell(k, 8).border = border;
        sheet.getCell(k, 8).value = '总计：';
        sheet.getCell(k, 9).border = border;
        sheet.getCell(k, 9).value = total;
        sheet.getCell(k, 10).border = border;
        // 插入总计公式
        if (record.tax_amount > 0) {
            sheet.getCell(k, 9).value = { formula: 'I' + (k - 2).toString() + '+I' + (k - 1).toString(), result: total };
        } else {
            sheet.getCell(k, 9).value = { formula: 'I' + (k - 1).toString(), result: total };
        }
        sheet.getCell(k, 9).numFmt = '0.00';    // 保留2位有效数字
        k += 1;

        // 插入4个空行
        sheet.addRows([[], [], [], []]);
        k += 4;
        // 插入报价信息
        if (record.offer_name) {
            // 报价单位
            sheet.addRow(['', '报价单位：' + record.offer_name]);
            k += 1;
        }
        if (record.offer_address) {
            // 地址
            sheet.addRow(['', '单位地址：' + record.offer_address]);
            k += 1;
        }
        if (record.offer_date) {
            // 时间
            sheet.addRow(['', '报价时间：' + record.offer_date]);
            k += 1;
        }
        if (record.offer_contacts) {
            // 联系人
            sheet.addRow(['', '联系人：' + record.offer_contacts]);
            k += 1;
        }
        if (record.offer_phone) {
            // 电话
            sheet.addRow(['', '电话：' + record.offer_phone]);
            k += 1;
        }
        if (record.offer_email) {
            // 邮箱
            sheet.addRow(['', '邮箱：' + record.offer_email]);
            k += 1;
        }
        if (record.description) {
            // 备注
            sheet.addRow(['', '备注：' + record.description]);
            k += 1;
        }
        if (record.description) {
            // 报价期限
            sheet.addRow(['', '*本报价有效期' + record.limit_month + '个月。'])
            sheet.getCell(k, 2).font = {
                color: { argb: 'FFFF0000' },
            };
        }

        // 保存
        workbook.xlsx.writeBuffer().then((buffer) => {
            let blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            saveAs(blob, record.name + '.v' + record.version + '.' + currentDate + '.xlsx');
            // 退出报表界面
            cancel();
        });
    }


    const columns = [
        { title: '序号', dataIndex: 'num', key: 'key', width: '14.85mm', align: 'center', },
        // {title: '产品编码',dataIndex: 'number',key: 'number', fixed: 'left',width: 140,},
        { title: '产品名称', dataIndex: 'name', key: 'name', width: '29.70mm', align: 'center', },
        {
            title: '参数', dataIndex: 'description', key: 'description', width: '98.01mm', textWrap: 'word-break',
            // 参数头部居中对齐，内容向左对齐
            onHeaderCell: (column) => { column.align = 'center' }
        },
        { title: '品牌', dataIndex: 'brand', key: 'brand', width: '17.82mm', align: 'center', },
        {
            title: '规格型号', key: 'model', width: '29.70mm', align: 'center',
            render: (record) => (
                <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
                    {record.model}
                </div>
            ),
        },
        { title: '单位', dataIndex: 'unit', key: 'unit', width: '14.85mm', align: 'center', },
        { title: '数量', dataIndex: 'count', key: 'count', width: '20.97mm', align: 'center', },
        { title: '单价', dataIndex: 'price', key: 'price', width: '26.73mm', align: 'center', },
        { title: '合计', dataIndex: 'amount', key: 'amount', width: '29.70mm', align: 'center', },
        { title: '备注', dataIndex: 'remark', key: 'remark', width: '17.82mm', align: 'center', },
    ];
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
                components: {
                    Table: {
                        /* 这里是你的组件 token */
                        borderColor: '#000',
                        headerBorderRadius: 0,
                        headerBg: '#D9D9D9'
                    },
                },
            }}
        >
            <Modal
                style={{ top: 0 }}
                closable={false}
                maskClosable={true}
                open={open}
                keyboard={true}
                width='297mm'
                onCancel={cancel}
                footer={[
                    <Radio.Group key='format' onChange={(e) => setFormat(e.target.value)} value={format}>
                        <Radio value='PDF'>PDF</Radio>
                        <Radio value='WORD'>WORD</Radio>
                        <Radio value='EXCEL'>EXCEL</Radio>
                    </Radio.Group>,
                    <Button key='cancel' onClick={cancel}>取消</Button>,
                    <Button key='submit' type='primary' disabled={props.btnLists.indexOf('btn_plms_project_offer_printer') >= 0 ? false : true} onClick={() => {
                        printer('PRINTER');
                    }}>打印</Button>,
                    <Button key='link' type='primary' disabled={props.btnLists.indexOf('btn_plms_project_offer_download') >= 0 ? false : true} onClick={() => {
                        printer('DOWNLOAD')
                    }}>下载</Button>,
                ]}
            >
                <div id='offer-print-info-id' className='offer-print-info' style={{ padding: '0 40px', marginTop: '50px', }}>
                    <Row style={{ margin: '15px' }}>
                        <Col span={2}><img src={props.preGroup === 'zhc' ? ZHCLOGO : XZTLOGO} height='70px' alt={props.preGroup === 'zhc' ? '智慧城' : '新致腾'} /></Col>
                        <Col span={4} offset={18}>
                            <p>报价币种：CNY</p>
                            <p>计价单位：元</p>
                        </Col>
                        <Col span={24} align='center'><h2>{props.record.name}</h2></Col>
                    </Row>
                    <Row style={{ marginBottom: 20 }}>
                        {
                            offerSorts && offerSorts.length > 0 && offerSorts.map((item) => {
                                // 分类数量
                                let sortCount = offerSorts.length;
                                // 封装数据
                                let ofLists = [];
                                let amount = 0;         // 金额小计
                                let taxAmount = 0;      // 税费小计
                                let n = 1;
                                for (let i = 0; i < dataLists.length; i++) {
                                    // 分类展示
                                    let ofListObj = dataLists[i];
                                    if (item.number === ofListObj.sort_number) {
                                        ofListObj.key = i + 1;
                                        ofListObj.num = n++;
                                        amount += parseFloat(ofListObj.amount);
                                        taxAmount += parseFloat(ofListObj.tax_amount);
                                        ofLists.push(ofListObj);
                                    }
                                }
                                return <div key={item.key}>
                                    {
                                        // 报价分类超过两项就打印分类名称
                                        sortCount > 1 ? <Row style={{
                                            borderTop: item.number === 1 ? '1px solid #000' : '0px solid #000',
                                            borderLeft: '1px solid #000',
                                            borderRight: '1px solid #000',
                                            width: '100%', height: '40px', lineHeight: '40px',
                                            fontWeight: 'bold',
                                        }}>
                                            <Col span={24} align='center'>{item.name}</Col>
                                        </Row> : ''
                                    }

                                    <Table
                                        columns={columns}
                                        size='small'
                                        style={{ width: '100%', borderRadius: 0 }}
                                        dataSource={ofLists}
                                        bordered={true}
                                        pagination={false}
                                        summary={() => (
                                            <Table.Summary fixed>
                                                <Table.Summary.Row>
                                                    <Table.Summary.Cell align='center' index={0} colSpan={8}>金额小计：</Table.Summary.Cell>
                                                    <Table.Summary.Cell align='center' index={8}>{amount.toFixed(CNF.DPL)}</Table.Summary.Cell>
                                                    <Table.Summary.Cell align='center' index={9}></Table.Summary.Cell>
                                                </Table.Summary.Row>
                                                {
                                                    taxAmount > 0 ? <Table.Summary.Row>
                                                        <Table.Summary.Cell align='center' index={0} colSpan={8}>税费小计：</Table.Summary.Cell>
                                                        <Table.Summary.Cell align='center' index={8}>{taxAmount.toFixed(CNF.DPL)}</Table.Summary.Cell>
                                                        <Table.Summary.Cell align='center' index={9}></Table.Summary.Cell>
                                                    </Table.Summary.Row> : ''
                                                }
                                                {
                                                    // 最后一个表格统计总金额
                                                    item.number === sortCount ? <Table.Summary.Row>
                                                        <Table.Summary.Cell align='center' index={0} colSpan={8}><strong>金额合计：</strong></Table.Summary.Cell>
                                                        <Table.Summary.Cell align='center' index={8}><strong>{props.record.amount}</strong></Table.Summary.Cell>
                                                        <Table.Summary.Cell align='center' index={9}></Table.Summary.Cell>
                                                    </Table.Summary.Row> : ''
                                                }
                                                {
                                                    // 税费大于0，最后一个表格统计总税额
                                                    props.record && props.record.tax_amount > 0 && item.number === sortCount ? <Table.Summary.Row>
                                                        <Table.Summary.Cell align='center' index={0} colSpan={8}><strong>税费合计：</strong></Table.Summary.Cell>
                                                        <Table.Summary.Cell align='center' index={8}><strong>{props.record.tax_amount}</strong></Table.Summary.Cell>
                                                        <Table.Summary.Cell align='center' index={9}></Table.Summary.Cell>
                                                    </Table.Summary.Row> : ''
                                                }
                                                {
                                                    // 最后一个表格统计合计
                                                    item.number === sortCount ? <Table.Summary.Row>
                                                        <Table.Summary.Cell align='center' index={0} colSpan={8}><strong>总计：</strong></Table.Summary.Cell>
                                                        <Table.Summary.Cell align='center' index={8}><strong>{(parseFloat(props.record.amount) + parseFloat(props.record.tax_amount)).toFixed(CNF.DPL)}</strong></Table.Summary.Cell>
                                                        <Table.Summary.Cell align='center' index={9}></Table.Summary.Cell>
                                                    </Table.Summary.Row> : ''
                                                }
                                            </Table.Summary>
                                        )}
                                    />
                                </div>
                            })
                        }
                    </Row>
                    {
                        props.record && props.record.offer_name ? <Row><Col span={7} offset={17} style={{ fontSize: '15px' }}>{props.record.offer_name}</Col></Row> : ''
                    }
                    <Row><Col span={7} offset={17} style={{ lineHeight: '40px' }}>{props.record.offer_date}</Col></Row>
                    {
                        props.record && props.record.offer_address ? <Row><Col span={12} style={{ lineHeight: '25px' }}>地址：{props.record.offer_address}</Col><Col span={12}></Col></Row> : ''
                    }

                    {
                        props.record && props.record.offer_contacts ? <Row><Col span={6} style={{ lineHeight: '25px' }}>联系人：{props.record.offer_contacts}</Col></Row> : ''
                    }
                    {
                        props.record && props.record.offer_phone ? <Row><Col span={6} style={{ lineHeight: '25px' }}>电话：{props.record.offer_phone}</Col></Row> : ''
                    }
                    {
                        props.record && props.record.offer_email ? <Row><Col span={12} style={{ lineHeight: '25px' }}>邮箱：{props.record.offer_email}</Col><Col span={12}></Col></Row> : ''
                    }
                    {
                        props.record && props.record.description ? <Row><Col span={12} style={{ lineHeight: '25px' }}>
                            <div>备注：</div>
                            <div>
                                {
                                    // 换行
                                    props.record.description.split('\n').map((item) => {
                                        return <div key={item}>{item}</div>
                                    })
                                }
                            </div>
                        </Col><Col span={12}></Col></Row> : ''
                    }
                    <Row><Col span={12} style={{ lineHeight: '25px', color: 'red' }}>*本报价有效期{props.record.limit_month ? props.record.limit_month : 3}个月。</Col><Col span={12}></Col></Row>
                </div >
            </Modal >
        </ConfigProvider>
    );
}
export default OfferPrinter